import { createSlice } from "@reduxjs/toolkit";
import { createSwapTransaction, cryptoWithdrawal, cryptoWithdrawalByTag, fetchCryptoTransactions, fiatToCrypto, generateSwapQuotation, getAllCoins, getChartData, getCoinById, getUserCryptoTransactions, tradeCryptoToFiat, tradeNewCoin, tradeOrderLimit, cancelOrderLimit } from "./cryptoActions";

const initialState = {
  loading: false,
  coins: [],
  coinNetworks: [],
  coinRates: [],
  coinLoading: false,
  coinRateLoading: false,
  barcodeLoading: false,
  cryptoInwardTransLoading: false,
  cryptoInwardTransactions: [],
  newcoinData: "",
  swapQuotation: {},
  chartLoading: false,
  chartError: false,
  chartData: [],
  transactions: {
    items: [],
    meta: {}
  },
};

const cryptoSlice = createSlice({
  name: "crypto",
  initialState, 
  reducers: {
    clearCoins: (state) => {
      state.coins = [];
    },
    clearRates: (state) => { 
      state.coinRates = [];
    },
    clearNewcoinData: (state) => {
      state.newcoinData = "";
    },
    // fond networks available in coin selected
    filterCoins: (state, { payload }) => {
      console.log(payload)
      state.coinNetworks = state.coins.find((coin)=> coin.id === payload).networks;
    },
    clearCoinNetwork: (state) => {
      state.coinNetworks = [];
    },
  },
  extraReducers: {
    // ========================== EXTRA RERDUCER HANDLING GET ALL COINS ACTION
    [getAllCoins.pending]: (state, { payload }) => {
      state.loading = true;
      state.coinLoading = true;
    },
    [getAllCoins.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.coinLoading = false;
      state.coins = payload.data;
    },
    [getAllCoins.rejected]: (state, { payload }) => {
      state.loading = false;
      state.coinLoading = false;
    },

    // ========================== EXTRA RERDUCER HANDLING GET ALL COINS ACTION
    [getCoinById.pending]: (state, { payload }) => {
      state.coinRateLoading = true;
    },
    [getCoinById.fulfilled]: (state, { payload }) => {
      state.coinRateLoading = false;
      state.coinRates = payload.data;
    },
    [getCoinById.rejected]: (state, { payload }) => {
      state.coinRateLoading = false;
    },


    // ========================== EXTRA RERDUCER HANDLING NEW COIN TRADE
    [tradeNewCoin.pending]: (state, { payload }) => {
      state.barcodeLoading = true;
    },
    [tradeNewCoin.fulfilled]: (state, { payload }) => {
      state.barcodeLoading = false;
      state.newcoinData = payload.data;
    },
    [tradeNewCoin.rejected]: (state, { payload }) => {
      state.barcodeLoading = false;
    },


    // ========================== EXTRA RERDUCER HANDLING FETCH CRYPTO TRANSACTIONS
    [fetchCryptoTransactions.pending]: (state, { payload }) => {
      state.cryptoInwardTransLoading = true;
    },
    [fetchCryptoTransactions.fulfilled]: (state, { payload }) => {
      state.cryptoInwardTransLoading = false;
      state.cryptoInwardTransactions = payload.data;
    },
    [fetchCryptoTransactions.rejected]: (state, { payload }) => {
      state.cryptoInwardTransLoading = false;
    },

    //  ========= generate swap quotation
    [generateSwapQuotation.pending]: (state) => {
      state.loading = true;
    },
    [generateSwapQuotation.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.swapQuotation = payload.data;
    },
    [generateSwapQuotation.rejected]: (state, { payload }) => {
      state.loading = false;
    },

    //  ========= create swap transaction
    [createSwapTransaction.pending]: (state) => {
      state.loading = true;
    },
    [createSwapTransaction.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [createSwapTransaction.rejected]: (state, { payload }) => {
      state.loading = false;
    },

    // ======== trade crypto to fiat
    [tradeCryptoToFiat.pending]: (state) => {
      state.loading = true;
    },
    [tradeCryptoToFiat.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [tradeCryptoToFiat.rejected]: (state, { payload }) => {
      state.loading = false;
    },

    // fiat to crypto
    [fiatToCrypto.pending]: (state) => {
      state.loading = true;
    },
    [fiatToCrypto.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [fiatToCrypto.rejected]: (state, { payload }) => {
      state.loading = false;
    },  

    // Crypto withdrawal
    [cryptoWithdrawal.pending]: (state) => {
      state.loading = true;
    },
    [cryptoWithdrawal.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [cryptoWithdrawal.rejected]: (state, { payload }) => {
      state.loading = false;
    },

    // crypto withdrawal by tag
    [cryptoWithdrawalByTag.pending]: (state) => {
      state.loading = true;
    },
    [cryptoWithdrawalByTag.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [cryptoWithdrawalByTag.rejected]: (state, { payload }) => {
      state.loading = false;
    },  

    // Trade order limit
    [tradeOrderLimit.pending]: (state) => {
      state.loading = true;
    },
    [tradeOrderLimit.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [tradeOrderLimit.rejected]: (state, { payload }) => {
      state.loading = false;
    },

    // cancel order limit
    [cancelOrderLimit.pending]: (state) => {
      state.loading = true;
    },
    [cancelOrderLimit.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [cancelOrderLimit.rejected]: (state) => {
      state.loading = false;
    },

    // get user transactions
    [getUserCryptoTransactions.pending]: (state) => {
        state.loading = true;
      },
      [getUserCryptoTransactions.fulfilled]: (state, { payload }) => {
        state.loading = false;
        state.transactions.items = payload.data?.transactions || [];
        state.transactions.meta = payload.data?.meta || {};
      },
      [getUserCryptoTransactions.rejected]: (state) => {
        state.loading = false;
    },

    // get chart data
    [getChartData.pending]: (state) => {
       state.chartLoading = true; 
      },
    [getChartData.fulfilled]: (state, { payload }) => { 
      state.chartLoading = false; 
      state.chartData = payload.data; 
      state.chartError = false
    },
    [getChartData.rejected]: (state) => { 
      state.chartLoading = false; 
      state.chartData = [];
      state.chartError = true
    },

  },
});

export default cryptoSlice.reducer;
export const {
  clearSignupSuccess,
  logout,
  clearHasResetPwd,
  clearCoins,
  clearRates,
  clearNewcoinData,
  filterCoins,
  clearCoinNetwork
} = cryptoSlice.actions;
